import styled from "styled-components";

export const Container = styled.div`
	min-height: 100vh;
	display: flex;
	background: #f9fafb;
`;

export const Main = styled.div`
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 2rem;
`;

export const Card = styled.div`
	max-width: 42rem;
	width: 100%;
	background: white;
	border-radius: 1rem;
	padding: 3rem;
	text-align: center;
	box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
`;

export const ErrorIconWrapper = styled.div`
	width: 6rem;
	height: 6rem;
	background: #fee2e2;
	border-radius: 50%;
	margin: 0 auto 2rem;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const Title = styled.h1`
	font-size: 2.25rem;
	font-weight: bold;
	color: #111827;
	margin-bottom: 1rem;
`;

export const Description = styled.p`
	font-size: 1.25rem;
	color: #4b5563;
	margin-bottom: 2rem;
`;

export const ErrorDetails = styled.div`
	background: #f9fafb;
	border-radius: 0.75rem;
	padding: 1.5rem;
	margin-bottom: 2rem;
	text-align: left;
`;

export const CodeBox = styled.div`
	background: white;
	border: 1px solid #e5e7eb;
	border-radius: 0.5rem;
	padding: 1rem;
	font-family: monospace;
	font-size: 0.875rem;
	color: #dc2626;
	word-break: break-word;
`;

export const ButtonGroup = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	justify-content: center;

	@media (min-width: 640px) {
		flex-direction: row;
	}
`;

export const Button = styled.button`
	display: inline-flex;
	align-items: center;
	padding: 0.75rem 2rem;
	font-weight: 600;
	border-radius: 0.75rem;
	border: none;
	cursor: pointer;
	transition: 0.2s;

	svg {
		margin-right: 0.5rem;
	}

	${(props) =>
		props.primary
			? `
    background: #6f57e9;
    color: white;
    box-shadow: 0 5px 15px rgba(79,70,229,0.4);

    &:hover {
      background: #4338ca;
    }
  `
			: `
    background: #f3f4f6;
    color: #374151;

    &:hover {
      background: #e5e7eb;
    }
  `}
`;

export const Footer = styled.div`
	margin-top: 3rem;
	padding-top: 2rem;
	border-top: 1px solid #f3f4f6;
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(8rem, 1fr));
	gap: 1.5rem;
	font-size: 0.875rem;
`;

export const FooterItem = styled.div`
	text-align: center;
`;

export const FooterTitle = styled.div`
	font-weight: 600;
	color: #111827;
	margin-bottom: 0.25rem;
`;

export const FooterText = styled.div`
	color: ${(props) => props.color || "#4b5563"};
`;

export const ExtraInfo = styled.div`
	margin-top: 2rem;
	text-align: center;
	font-size: 0.875rem;
	color: #6b7280;
`;
